import axios from './axios'
import store from 'shared/redux/store'
import { showSuccess, showError } from 'shared/redux/app/reducer'
import axiosLib, { AxiosRequestConfig, AxiosResponse } from 'axios'

export interface UploadBatchItem {
  filename: string
  file_type?: string
  file_sub_path?: string
}

export interface UploadBatchResponseItem {
  filename: string
  file_path: string
}

export interface UploadBatchResponse {
  items: UploadBatchResponseItem[]
}

export default async function getUploadLinkServiceBatch(
  config: AxiosRequestConfig,
  path: string,
  files: UploadBatchItem[],
  token = '',
  token_type = '',
): Promise<UploadBatchResponseItem[]> {
  try {
    if (!files.length) return []

    const response = await axios({
      url: token && token_type ? `/asset/public/upload/batch/${path}` : `/asset/upload/batch/${path}`,
      method: 'POST',
      data: {
        files,
        ...(token && token_type ? { token, token_type } : {}),
      },
      ...(config || {}),
    })

    const items = response?.data?.data || response?.data || []

    if (!Array.isArray(items) || items.length === 0) {
      throw new Error('Unable to get batch upload links.')
    }

    return items
  } catch (error) {
    console.error('getUploadLinkBatch error:', error)
    console.error('Response:', error.response?.data)
    store.dispatch(
      showError({
        message: error.response?.data?.message || error.message || 'Unable to get batch upload links',
      }),
    )
    throw error
  }
}

// export default async function getUploadLinkBatch(
//   config: AxiosRequestConfig,
//   filename: string,
//   file_type = '',
//   file_sub_path = '',
//   token = '',
//   token_type = '',
// ): Promise<UploadLinkResponse> {
//   try {
//     const source = axiosLib.CancelToken.source()
//     let response
//     if (token && token_type) {
//       response = await axios({
//         url: `/asset/public/upload/${filename}`,
//         method: 'GET',
//         params: {
//           file_type,
//           file_sub_path,
//           token,
//           token_type,
//         },
//         cancelToken: source.token,
//       })
//     } else {
//       response = await axios({
//         url: `/asset/upload/${filename}`,
//         method: 'GET',
//         params: {
//           file_type,
//           file_sub_path,
//         },
//         cancelToken: source.token,
//       })
//     }

//     const uploadLinkResponse: UploadLinkResponse = (response as unknown) as UploadLinkResponse

//     if (!uploadLinkResponse || !uploadLinkResponse.file_path) {
//       throw new Error('Unable to get upload link.')
//     }

//     return {
//       file_path: uploadLinkResponse.file_path,
//     }
//   } catch (error) {
//     store.dispatch(
//       showError({
//         message: error.message || 'An unknown error occurred',
//       }),
//     )
//     throw error
//   }
// }
